(function () {
  'use strict';

  var script = document.querySelector('script[data-snf-search-filters]');
  var labels = {
    printed: script ? script.getAttribute('data-printed-label') : 'Printed Garments',
    transfers: script ? script.getAttribute('data-transfers-label') : 'DTF Transfers',
    group: script ? script.getAttribute('data-group-label') : 'Filter search by product type'
  };
  var expressions = {
    transfers: 'title:DTF',
    printed: 'product_type:"Printed Clothing"',
    both: '(title:DTF OR product_type:"Printed Clothing")'
  };
  var suffixes = [
    ' AND ' + expressions.both,
    ' AND ' + expressions.transfers,
    ' AND ' + expressions.printed
  ];

  function cleanQuery(value) {
    var query = (value || '').trim();
    suffixes.forEach(function (suffix) {
      if (query.toLowerCase().slice(-suffix.length) === suffix.toLowerCase()) {
        query = query.slice(0, -suffix.length).trim();
      }
    });
    return query;
  }

  function categoryFor(group) {
    var printed = group.querySelector('[data-snf-search-filter="printed"]').checked;
    var transfers = group.querySelector('[data-snf-search-filter="transfers"]').checked;
    if (printed && transfers) return 'both';
    if (printed) return 'printed';
    if (transfers) return 'transfers';
    return '';
  }

  function setAllGroups(category) {
    document.querySelectorAll('.snf-search-categories').forEach(function (group) {
      group.querySelector('[data-snf-search-filter="printed"]').checked = category === 'printed' || category === 'both';
      group.querySelector('[data-snf-search-filter="transfers"]').checked = category === 'transfers' || category === 'both';
    });
  }

  function ensureCategoryInput(form) {
    var input = form.querySelector('input[name="snf_category"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'snf_category';
      form.appendChild(input);
    }
    return input;
  }

  function mount() {
    var params = new URLSearchParams(window.location.search);
    var initialCategory = params.get('snf_category') || '';
    var forms = Array.prototype.slice.call(document.querySelectorAll('form[action]'));

    forms.forEach(function (form) {
      var action;
      try {
        action = new URL(form.getAttribute('action'), window.location.href);
      } catch (error) {
        return;
      }
      if (!/\/search\/?$/.test(action.pathname)) return;

      var queryInput = form.querySelector('input[name="q"]');
      var field = form.querySelector('.field');
      if (!queryInput || !field || form.dataset.snfSearchReady === 'true') return;
      form.dataset.snfSearchReady = 'true';

      var group = document.createElement('div');
      group.className = 'snf-search-categories';
      group.setAttribute('data-snf-search-filters', '');
      group.setAttribute('role', 'group');
      group.setAttribute('aria-label', labels.group);

      [
        { key: 'printed', label: labels.printed },
        { key: 'transfers', label: labels.transfers }
      ].forEach(function (item) {
        var label = document.createElement('label');
        label.className = 'snf-search-category';
        var checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.setAttribute('data-snf-search-filter', item.key);
        checkbox.value = item.key;
        var text = document.createElement('span');
        text.textContent = item.label;
        label.appendChild(checkbox);
        label.appendChild(text);
        group.appendChild(label);
      });

      field.insertAdjacentElement('afterend', group);
      var categoryInput = ensureCategoryInput(form);
      categoryInput.value = initialCategory;
      queryInput.value = cleanQuery(queryInput.value);

      group.addEventListener('change', function () {
        var category = categoryFor(group);
        setAllGroups(category);
        document.querySelectorAll('form[action]').forEach(function (otherForm) {
          var hidden = otherForm.querySelector('input[name="snf_category"]');
          if (hidden) hidden.value = category;
        });
      });

      form.addEventListener('submit', function () {
        var query = cleanQuery(queryInput.value);
        var category = categoryFor(group);
        categoryInput.value = category;
        queryInput.value = category ? (query ? query + ' AND ' + expressions[category] : expressions[category]) : query;
      });
    });

    if (['printed', 'transfers', 'both'].indexOf(initialCategory) !== -1) {
      setAllGroups(initialCategory);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, { once: true });
  } else {
    mount();
  }
})();